<mat-radio-group [formControl]="formControlRef">
  <mat-label style="font-size :1.2rem">{{ fieldObject.fieldName }}</mat-label> <br>
  <mat-radio-button *ngFor="let fieldValue of fieldObject.fieldValues" [value]="fieldValue.name">
    {{ fieldValue.name }}
  </mat-radio-button>
<span style="color: red;" *ngIf="fieldErrors[fieldObject.fieldName]|| fieldErrors[fieldErrorName]">
{{ fieldErrors[fieldObject.fieldName]|| fieldErrors[fieldErrorName] }}
  </span>
</mat-radio-group>
